import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { BehaviorSubject, Subscription } from 'rxjs';
import { LocalOffersDataSource } from 'src/modules/local-offers/services/local-offers-data-source';
import { LocalOffersApiService } from 'src/modules/local-offers/services/local-offers-api-service';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { LocationsList } from 'src/modules/location/components/list/component';
import { LocalOffersEdit } from 'src/modules/local-offers/components/edit/component';
import { CategoryDataSource } from 'src/modules/category/services/category-data-source';
import { CategoryApiService } from 'src/modules/category/services/category-api-service';
import { CategoriesList } from 'src/modules/category/components/list/component';

@Component({
    selector: 'local-offers-dashboard',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class LocalOffersDashboard implements OnInit, OnDestroy {
  @Input() currentTab: BehaviorSubject<string>;
  private Subscriptions: Subscription[] = [];
  public DataSource = new LocalOffersDataSource(this.LocalOffersApi, 'admin');
  public loading: boolean;
  public LocalOffers;
  public PageEvent: PageEvent;
  private CategoryDataSource: CategoryDataSource;
  public displayedColumns = ['company_name', 'offer', 'actions'];

  constructor(
    private dialog: MatDialog,
    private LocalOffersApi: LocalOffersApiService,
    protected dialogRef: MatDialogRef<LocationsList>,
    private CategoryApi: CategoryApiService
  ) {}
  ngOnInit() {
    this.Subscriptions.push(
      this.DataSource.loading.subscribe((_loading) => (this.loading = _loading))
    );

    this.Subscriptions.push(
      this.DataSource.connect().subscribe(
        (_LocalOffers) => (this.LocalOffers = _LocalOffers)
      )
    );
    this.Subscriptions.push(
      this.DataSource.PageEvent.subscribe(
        (_PageEvent) => (this.PageEvent = _PageEvent)
      )
    );
    this.Subscriptions.push(
      this.DataSource.filter.subscribe(
        (filter) => filter && this.DataSource.loadWithPageEvent(this.PageEvent)
      )
    );

    this.Subscriptions.push(
      this.currentTab.subscribe(
        (tab) =>
          'local-offers-admin' === tab &&
          this.DataSource.loadWithPageEvent(this.PageEvent)
      )
    );
  }

  public setSearch(search: string) {
    this.DataSource.setFilter('searchString', search);
  }

  public editLocalOffer(LocalOffer?) {
    const config = new MatDialogConfig();
    config.disableClose = true;
    config.data = {
      LocalOffer,
      dataSource: this.DataSource,
    };
    this.dialog.open(LocalOffersEdit, config);
  }

  public deleteLocalOffer(LocalOffer) {
    console.log(LocalOffer);
    confirm('Are you sure you want to delete: ' + LocalOffer.offer) &&
      this.DataSource.delete(LocalOffer);
  }

  ngOnDestroy() {
    this.DataSource.disconnect();
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }

  public listCategories(categoryId) {
    this.CategoryDataSource = new CategoryDataSource(
      this.CategoryApi,
      'admin',
      categoryId,
      true
    );
    const config = new MatDialogConfig();
    config.data = this.CategoryDataSource;
    config.disableClose = true;
    return this.dialog.open(CategoriesList, config);
  }
}
